export const genders = ['Female', 'Male', 'Transgender Female', 'Transgender Male', 'Gender Variant/Non-Conforming', 'Preferer Not To Answer']
export const races = [' Hispanic/Latino', 'American Indian or Alaska Native', 'Asian', 'Black or African American',
    'Native Hawaiian or Other Pacific Islander', 'White', 'Two or more races']
export const roles = [
    {value: 'a', label: 'Child/Student/Patient'},
    {value: 'b', label: 'Parent/Caretaker'},
    {value: 'c', label: 'Healthcare Admin'},
    {value: 'd', label: 'School Admin'},
    {value: 'e', label: 'Psychologist (Psy)'},
    {value: 'f', label: 'Occupational Therapist'},
    /*{ value: 'g', label: 'Resource Specialist (RSP)' },*/
    {value: 'g', label: 'Speech and Language Pathologist (SLP)'},
    {value: 'h', label: 'Developer/Tester'},
    {value: 'i', label: 'Press/Media'},
    {value: 'j', label: 'Volunteer'},
    {value: 'k', label: 'Financial Contributor'},
    {value: 'l', label: ''},
    {value: 'm', label: ''},
    {value: 'n', label: ''},
    {value: 'o', label: ''},
]

export const specialists = [
    {value: 'a', label: 'Child Counselor'},
    {value: 'b', label: 'Language Therapist'},
    {value: 'c', label: 'Neuro-pediatrician'},
    {value: 'd', label: 'Occupational Therapist (OT)'},
    {value: 'e', label: 'Occupational Therapist Assistant (OTA)'},
    {value: 'f', label: 'Physical Therapist/Kinesiologist'},
    {value: 'g', label: 'Psychologist'},
    {value: 'h', label: 'Psychotherapist'},
    {value: 'i', label: 'Reading Specialist (RSP)'},
    {value: 'j', label: 'Resource Specialist (RSP)'},
    {value: 'k', label: 'Social Worker'},
    {value: 'l', label: 'Special Education Teacher'},
    {value: 'm', label: 'Speech & Language Pathologist (SLP)'},
    {value: 'n', label: 'Speech & Language Pathologist Assistant (SLPA)'},
    {value: 'o', label: 'Speech Therapist'},
]
